import { EntityRatingCommentCount, EntityRatingCommentCountDocument } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getEntityRatingCommentCountService(id: string, page: number = 1): Promise<EntityRatingCommentCount | null | undefined> {
  const { data } = await ApolloClient.query({
    query: EntityRatingCommentCountDocument,
    variables: { id, page },
  });

  return data?.entityRatingCommentCount;
}
